import { AccountBalanceWallet } from '@mui/icons-material'
import { Box, Button, Container, Grid, Stack, Typography } from '@mui/material'
import { useAuth } from '../providers/auth'
import { Link as RouterLink, Navigate } from 'react-router-dom'
import TableContainer from '../components/admin/table-container'
import { features } from '../config/features'

export default function Admin() {
  const { admin } = useAuth()

  if (!admin) return <Navigate to="/" replace></Navigate>

  return (
    <Container maxWidth="lg" sx={{ position: 'relative' }}>
      <Box sx={{ height: 16 }} />
      <Grid container spacing={2} alignItems="flex-start">
        <Grid item xs={12}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            justifyContent="space-between"
          >
            <Typography variant="h6" component="h1">
              Administratörsverktyg
            </Typography>
            {features.credits && (
              <Button
                component={RouterLink}
                to="/admin/credits"
                variant="outlined"
                startIcon={<AccountBalanceWallet />}
              >
                Hantera credits
              </Button>
            )}
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <TableContainer />
        </Grid>
      </Grid>
      <Box sx={{ height: 64 }} />
    </Container>
  )
}
